var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "92px",
    height: "92px",
    viewBox: "0 0 92 92",
    enableBackground: "new 0 0 92 92",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1126_",
    d: "M78.5,13.5C69.8,4.8,58.3,0,46,0c0,0,0,0,0,0C33.7,0,22.2,4.8,13.5,13.5C4.8,22.2,0,33.7,0,46 s4.8,23.8,13.5,32.5C22.2,87.2,33.7,92,46,92c12.3,0,23.8-4.8,32.5-13.5C87.2,69.8,92,58.3,92,46C92,33.7,87.2,22.2,78.5,13.5z  M69.5,40.4l13.7-2.1c0.5,2.5,0.8,5.1,0.8,7.7c0,2.6-0.3,5.2-0.8,7.7l-13.7-2.1C70.3,47.9,70.3,44.1,69.5,40.4z M81.5,32.4 l-14.2,2.2c-1.1-2.1-2.5-4-4.2-5.7c-1.7-1.7-3.7-3.2-5.7-4.2l2.2-14.2c4.9,1.9,9.5,4.8,13.3,8.6C76.7,23,79.6,27.5,81.5,32.4z  M46,62.2c-4.3,0-8.4-1.7-11.4-4.7c-3.1-3.1-4.7-7.1-4.7-11.4s1.7-8.4,4.7-11.4c3.2-3.2,7.3-4.7,11.4-4.7s8.3,1.6,11.4,4.7 c3.1,3.1,4.7,7.1,4.7,11.4c0,4.3-1.7,8.4-4.7,11.4C54.4,60.5,50.3,62.2,46,62.2z M46,8c2.6,0,5.2,0.3,7.7,0.8l-2.1,13.7 c-3.7-0.9-7.5-0.9-11.2,0L38.3,8.8C40.8,8.3,43.4,8,46,8z M19.1,19.1c3.8-3.8,8.4-6.8,13.3-8.6l2.2,14.2c-2.1,1.1-4,2.5-5.7,4.2 c-1.7,1.7-3.1,3.7-4.3,5.7l-14.2-2.2C12.4,27.5,15.3,23,19.1,19.1z M8,46c0-2.6,0.3-5.2,0.8-7.7l13.7,2.1c-0.4,1.8-0.7,3.7-0.7,5.6 c0,1.9,0.2,3.8,0.7,5.6L8.8,53.7C8.3,51.2,8,48.6,8,46z M10.5,59.6l14.2-2.2c1.1,2.1,2.5,4,4.3,5.7c1.7,1.7,3.7,3.1,5.7,4.3 l-2.2,14.2c-4.9-1.9-9.5-4.8-13.3-8.6C15.3,69,12.4,64.5,10.5,59.6z M46,84c-2.6,0-5.2-0.3-7.7-0.8l2.1-13.7 c1.8,0.4,3.7,0.7,5.6,0.7h0c1.9,0,3.8-0.2,5.6-0.7l2.1,13.7C51.2,83.7,48.6,84,46,84z M72.9,72.9c-3.8,3.8-8.4,6.8-13.3,8.6 l-2.2-14.2c2.1-1.1,4-2.5,5.7-4.3c1.7-1.7,3.2-3.7,4.2-5.7l14.2,2.2C79.6,64.5,76.7,69,72.9,72.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.28b9b44db0c9fa80360dad8c3fe88172.svg";
export { ForwardRef as ReactComponent };